import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/auto-verkaufen/")({
  head: () => routeHead("/de/auto-verkaufen/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/vinde-masina", statusCode: 301, replace: true });
  },
});
